import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { CartUpdateService } from './cartUpdate.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';

@Injectable()
export class CartItemsCookieService{

    constructor(
        private cookieService: CookieService,
        private cartUpdateService: CartUpdateService,
        private snotifyService: SnotifyService
    ){}

    addItemIdToCartCookie(id: number){
        if(this.cookieService.check('ids')){
            var addedItemIds = this.cookieService.get('ids');
            var addedItemsArray = JSON.parse(addedItemIds);
            addedItemsArray.push(id);

            // this.cookieService.set('ids', JSON.stringify(addedItemsArray), 1, '/');

            this.cookieService.set('ids', JSON.stringify(addedItemsArray), 1, '/', "", true, "None");
    
        }else{
            // this.cookieService.set('ids', JSON.stringify([id]), 1, '/');
            this.cookieService.set('ids', JSON.stringify([id]), 1, '/', "", true, "None");
        }

        // notify cart about the change
        this.cartUpdateService.emitCartChangeEvent();
    }

    getItemIdsFromCartCookie(): number[]{
        if(this.cookieService.check('ids')){
            var addedItemIds = this.cookieService.get('ids');
            var addedItemsArray = JSON.parse(addedItemIds);
            return addedItemsArray;
        }else{
            return [];
        }
    }

    public deleteCartCookie() {
        this.cookieService.delete('ids');
    }

    updateQuantityForId(quantity: number, courseId: number){
        var addedItemIds = this.getItemIdsFromCartCookie();
        addedItemIds = addedItemIds.filter((id) => id != courseId);
 
        for(var i=0; i<quantity; i++){
            addedItemIds.push(courseId);
        }

        this.cookieService.delete('ids', "/", "");
        this.cookieService.set('ids', JSON.stringify(addedItemIds), 1, '/', "", true, "None");
    }

    deleteItemFromCart(courseId: number){
        var addedItemIds = this.getItemIdsFromCartCookie();
        addedItemIds = addedItemIds.filter((id) => id != courseId);
        this.cookieService.delete('ids', "/", "");
        this.cookieService.set('ids', JSON.stringify(addedItemIds), 1, '/', "", true, "None");

        // notify cart about the change
        this.cartUpdateService.emitCartChangeEvent();
    }

    emptyCart(){
        this.cookieService.delete('ids', "/", "");
        // notify cart about the change
        this.cartUpdateService.emitCartChangeEvent();
    }

    setRegistrationTypeCookie(regType: string){
        this.cookieService.delete('regTypeCookie', "/", "");
        this.cookieService.set('regTypeCookie', regType, 1, '/', "", true, "None");
    }

    getRegistrationTypeFromCookie(){
        if(this.cookieService.check('regTypeCookie')){
            var regType = this.cookieService.get('regTypeCookie');
            return regType;
        }else{
            this.cookieService.set('regTypeCookie', 'standard', 1, '/', "", true, "None");
            return 'standard';
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/Services/cartItemsCookie.service.ts